import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import type { FC } from "react";
import PsychologyAltRoundedIcon from "@mui/icons-material/PsychologyAltRounded";

export const ContactQRCode: FC = () => {
  // responsive UI
  const theme = useTheme();
  const notPhone = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Grid size={{ xs: 12, sm: 8 }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "5px",
          padding: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <PsychologyAltRoundedIcon
            color="secondary"
            sx={{ width: "24px", height: "24px" }}
          />
          <Typography
            variant="h5"
            color="secondary"
            fontStyle="italic"
            fontWeight={700}
          >
            请联系：
          </Typography>
        </Box>

        <Typography
          variant="h6"
          color="primary"
          onClick={() => (window.location.href = `mailto:bd@lingqi.tech`)}
          sx={{
            marginTop: notPhone ? 0 : "8px",
            ":hover": {
              cursor: "pointer",
              textDecoration: "underline",
            },
          }}
        >
          bd@lingqi.tech
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "180px",
            padding: "16px 0",
          }}
        >
          <img
            src={"qrCode/contact_me_qr.png"}
            alt={`learn and communicate group`}
            style={{
              width: "140px",
              height: "140px",
              border: `1px solid ${theme.palette.secondary.dark}`,
              boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
              borderRadius: "5px",
            }}
          />
        </Box>
      </Box>
    </Grid>
  );
};
